import React from "react";
import {
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Stack,
  Button,
} from "@mui/material";

import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";

import { BootstrapInput } from "../../../../../../../components/widgets/BootstrapInput";
import { usePoContext } from "./poContext";

const POSelection = () => {
  const {
    selectedPo,
    handleNumberChange,
    pos,
    handleRevisionChange,
    revisions,
    onAddSelectedDrawing,
  } = usePoContext();

  console.log("selectedPo", selectedPo);

  return (
    <Stack direction={"row"}>
      <FormControl
        variant="standard"
        size="small"
        sx={{ m: 1, ml: 0, mt: 0, minWidth: 120 }}
        margin="normal"
      >
        <InputLabel id="mrq-label" shrink sx={{ fontSize: "1.1rem" }}>
          PO Number
        </InputLabel>
        <Select
          value={selectedPo.poNumber}
          onChange={handleNumberChange}
          input={<BootstrapInput />}
        >
          {Array.from(new Set(pos?.map((d) => d.poNumber))).map((poNumber) => (
            <MenuItem key={poNumber} value={poNumber}>
              {poNumber}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      <FormControl
        variant="standard"
        size="small"
        sx={{ m: 1, ml: 0, mt: 0, minWidth: 120 }}
        margin="normal"
        disabled={!selectedPo.poNumber}
      >
        <InputLabel id="mrq-label" shrink sx={{ fontSize: "1.1rem" }}>
          Revision
        </InputLabel>
        <Select
          value={selectedPo.revision}
          onChange={handleRevisionChange}
          input={<BootstrapInput />}
        >
          {revisions?.map((rev) => (
            <MenuItem key={rev} value={rev}>
              {rev}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      <FormControl
        variant="standard"
        size="small"
        sx={{ m: 1, ml: 0, mt: 0, minWidth: 120 }}
        margin="normal"
        disabled
      >
        <InputLabel id="mrq-label" shrink sx={{ fontSize: "1.1rem" }}>
          Title
        </InputLabel>
        <Select value={selectedPo.title} input={<BootstrapInput />}>
          <MenuItem value={selectedPo.title}>{selectedPo.title}</MenuItem>
        </Select>
      </FormControl>

      <Button
        variant="contained"
        sx={{ mt: 3, ml: 0, mb: 2 }}
        startIcon={<AddCircleOutlineIcon />}
        onClick={onAddSelectedDrawing}
      >
        Add
      </Button>
    </Stack>
  );
};

export default POSelection;
